import { TALENT_ID } from '../ids/talent-id'
import { TalentMap } from 'web/data/models'
import { SPEC_ID } from '../ids/spec-ids'

export const MONK_TALENTS: TalentMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Mistweaver
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [TALENT_ID.MONK.MW.CHI_JI]: {
        id: TALENT_ID.MONK.MW.CHI_JI,
        specId: SPEC_ID.MONK.MW,

        name: "Invoke Chi-Ji, the Red Crane",
        shortName: "Chi-ji",

        game_id: 198664,
        icon_name: "inv_pet_cranegod"
    },

}
